import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Xoa } from "./Xoa";

export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img  src="/app-assets/images/icon-button-xoa-v2.png"/>
        </PopoversBootrap>
      </a>
      {show && (
        <Xoa show={show} onHide={handleClose} thanhlyId={item.ThanhLyID} />
      )}
    </>
  );
};
